import React from 'react';
import type { Diffusion } from '../hooks/useDiffusions';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';

interface Props {
  diffusion: Diffusion;
  onStatusChange: (id: string, newStatus: string, oldStatus: string, barName: string, matchName: string) => void;
}

export function DiffusionRow({ diffusion, onStatusChange }: Props) {
  const barName = diffusion.bars?.name || '?';
  const matchName = diffusion.matches
    ? `${diffusion.matches.home_team} vs ${diffusion.matches.away_team}`
    : '?';
  const matchDateTime = diffusion.matches
    ? format(new Date(diffusion.matches.match_date + 'T00:00:00'), 'EEE d MMM', { locale: fr }) + ' · ' + diffusion.matches.match_time
    : '-';

  const statusClass = `status-select ${diffusion.status}`;

  return (
    <tr>
      <td style={{ fontWeight: 600 }}>{barName}</td>
      <td>{matchName}</td>
      <td style={{ fontSize: '12px', color: 'var(--text-muted)' }}>{matchDateTime}</td>
      <td>
        <select
          className={statusClass}
          value={diffusion.status}
          onChange={(e) => onStatusChange(diffusion.id, e.target.value, diffusion.status, barName, matchName)}
        >
          <option value="unconfirmed">Non vérifié</option>
          <option value="probable">Probable</option>
          <option value="confirmed">Confirmé</option>
        </select>
      </td>
      <td style={{ fontSize: '12px', color: 'var(--text-dim)' }}>{diffusion.confirmed_by || '-'}</td>
      <td style={{ fontSize: '12px', color: 'var(--text-dim)' }}>
        {diffusion.confirmed_at ? format(new Date(diffusion.confirmed_at), 'dd/MM HH\'h\'mm', { locale: fr }) : '-'}
      </td>
    </tr>
  );
}
